import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import * as ReduxDOMRender from 'redux-stores/ReduxDOMRender';
import StorableResultsTabState from 'results/linked-results/StorableResultsTabState';
import StorableResultsView from 'results/linked-results/StorableResultsView';

export default class StorableResultsTabView extends BufferTabView<StorableResultsTabState> {
  render(): this {
    const storableId = this.model.get('storableId');
    ReduxDOMRender.renderToDOM(<StorableResultsView storableId={storableId} />, this.el);
    return this;
  }

  remove(): Backbone.View<StorableResultsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

StorableResultsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
